import ToppingsSetterDesktop from './ToppingsSetterDesktop';

export default ToppingsSetterDesktop;
